import { JSX } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { Dialog } from "../Dialog/Dialog";
import { DialogContent } from "../Dialog/DialogContent";
import { DialogFooter } from "../Dialog/DialogFooter";
import { Card } from "../../Cards/Card/Card";
import { GridContainer } from "../../Layout/Grid/GridContainer";
import { GridItem } from "../../Layout/Grid/GridItem";
import { ButtonBar } from "../../Buttons/ButtonBar/ButtonBar";
import { RightButtons } from "../../Buttons/ButtonBar/RightButtons";
import { Button } from "../../Buttons/Button/Button";
import { CopyButton } from "../../Buttons/CopyButton/CopyButton";
import { Divider } from "@serendie/ui";
import { Typography } from "../../Typography/Typography/Typography";
import { List } from "../../Lists/List/List";
import { ListItem } from "../../Lists/List/ListItem";

export class ApiErrorDialog extends BaseComponent<IApiErrorDialogProps, IApiErrorDialogState>
{
    public static dialogTitle = '';
    public static okButtonLabel = '';

    private handleCopyClick(): string
    {
        const { errorTitle, errorDetails, messages, status, instance, time } = this.props;
        const lines: string[] = [];

        if (errorTitle)
        {
            lines.push(`- ${errorTitle}`);
        }

        if (errorDetails) 
        {
            lines.push(`  - ${errorDetails}`);
        }

        for (const message of messages)
        {
            lines.push(`  - ${message}`);
        }

        lines.push(`  - Status: ${status}`);
        lines.push(`  - Instance: ${instance}`);
        lines.push(`  - Time: ${time}`);

        return lines.join('\n');
    }

    public render(): JSX.Element
    {
        const { errorTitle, errorDetails, messages, status, instance, time, show, onClose } = this.props;

        return (
            <Dialog
                isOpen={show && messages.length > 0}
                onOpenChange={() => onClose()}
                width={5}
                zIndex={10000}
            >
                <DialogContent>
                    <Card
                        title={this.props.dialogTitle ?? ApiErrorDialog.dialogTitle}
                        actions={<CopyButton onClick={() => this.handleCopyClick()} />}
                    >
                        <GridContainer
                            spacing="xs"
                        >
                            { errorTitle?.length > 0 &&
                                <GridItem>
                                    {errorTitle}
                                </GridItem>
                            }
                            { errorDetails?.length > 0 &&
                                <GridItem>
                                    <ul
                                        style={{
                                            listStyleType: 'disc',
                                            paddingLeft: 'var(--spacing-sd-system-dimension-spacing-extra-large)'
                                        }}
                                    >
                                        <li>{errorDetails}</li>
                                    </ul>
                                </GridItem>
                            }
                            <GridItem>
                                <ul
                                    style={{
                                        listStyleType: 'disc',
                                        paddingLeft: 'var(--spacing-sd-system-dimension-spacing-extra-large)'
                                    }}
                                >
                                    {messages.map(message => <li>{message}</li>)}
                                </ul>
                            </GridItem>
                            <GridItem>
                                <Divider />
                            </GridItem>
                            <GridItem>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 'var(--spacing-sd-system-dimension-spacing-extra-small)',
                                    }}
                                >
                                    {[
                                        { label: 'Status', value: status },
                                        { label: 'Instance', value: instance },
                                        { label: 'Time', value: time }
                                    ].map(({ label, value }) => (
                                        <div
                                            key={label}
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <span>{label}</span>
                                            <span>{value}</span>
                                        </div>
                                    ))}
                                </div>
                            </GridItem>
                        </GridContainer>
                    </Card>
                </DialogContent>
                <DialogFooter>
                    <ButtonBar>
                        <RightButtons>
                            <Button
                                styleType='filled'
                                onClick={() => onClose()}
                            >
                                {this.props.okButtonLabel ?? ApiErrorDialog.okButtonLabel}
                            </Button>
                        </RightButtons>
                    </ButtonBar>
                </DialogFooter>
            </Dialog>
        );
    }
}

export interface IApiErrorDialogProps
{
    dialogTitle?: string;
    okButtonLabel?: string;
    show: boolean;
    errorTitle: string;
    errorDetails: string;
    messages: string[];
    status: number;
    instance: string;
    time: string;
    onClose: () => void;
}

export interface IApiErrorDialogState { }
